import { render, staticRenderFns } from "./ProceedToPaymentPackageModal.vue?vue&type=template&id=38027a0c&scoped=true"
import script from "./ProceedToPaymentPackageModal.vue?vue&type=script&lang=js"
export * from "./ProceedToPaymentPackageModal.vue?vue&type=script&lang=js"
import style0 from "./ProceedToPaymentPackageModal.vue?vue&type=style&index=0&id=38027a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38027a0c",
  null
  
)

export default component.exports